import ResumeOptions from './resume-options'

export default ResumeOptions
